import React, { useState, useEffect } from 'react';
import { Button,Grid,  RadioGroup, Radio,FormControlLabel } from '@mui/material';
import { useForm } from "react-hook-form";
import {apiLogin} from '../../services/api/accounts/Login';
import {authVerify} from "../../services/api/utilities/AuthVerify";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import {isMobile,useMobileOrientation } from 'react-device-detect';
import { useTranslation } from "react-i18next";

const SettingsComponent = (props) => {
    const { register, handleSubmit, reset, setValue} = useForm();
    const [validationMessage, setValidationMessage] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [paymentsMode, setPaymentsMode] = useState(false);
    const [model, setModel] = useState({});
    const [settingSeparetly, setSettingSeparetly] = useState(1);
    const { t, i18n, ready } = useTranslation();
    
    useEffect(() => {
        authVerify.verifyUser();
        async function fetchData() {
            let user = await apiLogin.getCurrentUser();
            if(user!==null)
            {
                setSettingSeparetly(user.settingSeparetly ? 2:1);
                setModel(user);
                reset(user);
            }
        }
        fetchData();
    }, [reset]);

    const handleClose = () => {
        props.setIsOpenSettings(false);
        setEditMode(false);
    };

    const onSubmit = async (data) => {
        let user = await apiLogin.getCurrentUser();
        user.summarySeparetly = settingSeparetly == 2;
        await apiLogin.saveCurrentUser(model);
        if(user!==null)
        {
            setModel(user);
            reset(user);
        }
        props.setIsOpenSettings(false);
        setEditMode(false);
    }

    const setSettings = (value) => {
        setSettingSeparetly(value)
        setModel(model);
    }

    return (
        <Dialog open={props.isOpenSettings} onClose={handleClose} style={{padding:"10px"}} maxWidth="lg" fullWidth>
            <div className='dialog-user'>
                <form autoComplete="none" onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    {t("settings_text1")}
                </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <a className="x dialog-close" onClick={handleClose}></a>
                            <Grid>
                                <h2>{t("settings_text2")}</h2>
                            </Grid>
                            <br/>
                            <Grid container>
                                <RadioGroup className="radio" defaultValue={settingSeparetly} onChange={(event)=>setSettings(event.target.value)}>
                                    <FormControlLabel value="2" control={<Radio />} label={t("settings_text3")}/>
                                    <FormControlLabel value="1" control={<Radio />} label={t("settings_text4")}/>
                                </RadioGroup>
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Grid container spacing={2} className="right-side action-margin mobile-buttons">
                            <a className="button button-cancel" fullWidth onClick={()=>handleClose()}>{t("user_text12")}</a>&nbsp;&nbsp;
                            <Button className="button" type="submit">{t("user_text13")}</Button>
                        </Grid>
                    </DialogActions>
                </form>
            </div>
        </Dialog>
    );
}

export default SettingsComponent;